(function () {
  "use strict";

  // Microsoft Clarity — Pampas Mood
  (function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "y7v3m2sxzf");

  // Hero banners are defined in sections/shoppable-hero.liquid.
  // Do not rewrite their images or links at runtime.

  // Preserve and load the original Maven CRM listener copied from this theme.
  var current = document.currentScript;
  if (!current || !current.src) return;

  try {
    var originalSrc = new URL(current.src);
    originalSrc.pathname = originalSrc.pathname.replace(/crm-webhook\.js$/, "crm-webhook-original.js");
    originalSrc.search = "";

    var originalScript = document.createElement("script");
    originalScript.src = originalSrc.toString();
    originalScript.async = false;
    current.parentNode.insertBefore(originalScript, current.nextSibling);
  } catch (error) {
    if (window.console) console.error("[pampas-clarity] Could not load original CRM listener", error);
  }
})();